import { StarIcon } from '@/assets/Icon/star';
import CommonModal from '@/features/captable/components/Shared/CommonModal';
import { Flex, Typography } from 'antd';
import themeToken from '@lib/theme/tokens/index';
import UpgradePackageCard from './UpgradePackageCard';
import { useGetPackages } from '@/features/premium/api/getPackages';

const { Text } = Typography;

type UpgradePackageModalProps = {
  handleClose: () => void;
  companyID: number;
  isOpen: boolean;
  t: (t: string) => string;
  setSelectedPackage: (packageData: { id: number; name: string; price: number }) => void;
  setIsPaymentModalOpen: (isOpen: boolean) => void;
};

function UpgradePackageModal({
  handleClose,
  companyID,
  isOpen,
  setSelectedPackage,
  t,
  setIsPaymentModalOpen,
}: UpgradePackageModalProps) {
  const { data: packages } = useGetPackages({ companyID });

  return (
    <CommonModal width={600} isModalOpen={isOpen} handleCancel={handleClose}>
      <Flex align="center" gap={8}>
        <StarIcon fillColor={themeToken['branding-primary-6']} width={20} height={20} />
        <Text style={{ color: themeToken['branding-primary-6'], fontSize: 16, fontWeight: 'bold' }}>
          {t('upgradeYourPackage')}
        </Text>
      </Flex>
      <div
        style={{
          padding: '16px',
          overflowY: 'auto',
          maxHeight: 'calc(100vh - 200px)',
        }}
      >
        {packages?.data.map((feature) => (
          <UpgradePackageCard
            key={feature.id}
            // icon={feature.icon}
            title={feature.name}
            t={t}
            price={`${feature.price}`}
            limit={feature.limit}
            canBePurchased={feature.can_be_purchased}
            // features={feature.features.map((f) => f.name)}
            onClick={() => {
              setSelectedPackage({ id: feature.id, name: feature.name, price: feature.price });
              setIsPaymentModalOpen(true);
            }}
          />
        ))}
      </div>
    </CommonModal>
  );
}

export default UpgradePackageModal;
